export default __webpack_public_path__ + "static/media/ui_table.90566400.png";